import { jsx as _jsx } from "react/jsx-runtime";
import React, { useEffect } from 'react';
import TenantSelect from '../../../routes/app/components/TenantSelect';
import axios from "axios";
import { axiosErrorHandler, setOrRemoveSessionStorageItem } from "../../../swzutils";
import { useSessionStorage } from "usehooks-ts";
import { useAppDispatch } from "../../../store";
import { changeTenant } from "../../../store/slice/auth";
const TenantSelector = () => {
    const dispatch = useAppDispatch();
    const [stateSelectedTenantId, setStateSelectedTenantId] = useSessionStorage("multi_tenant_selected_id", null);
    // On initial load / retrieval from session storage, propagate the value via onChange
    useEffect(() => {
        if (stateSelectedTenantId) {
            onChange(stateSelectedTenantId);
        }
    }, []);
    const onChange = (selectedTenantId) => {
        // console.log('XXX TenantSelector onChange selectedTenantId', selectedTenantId);
        setOrRemoveSessionStorageItem("multi_tenant_selected_id", selectedTenantId);
        setStateSelectedTenantId(selectedTenantId);
        if (selectedTenantId) {
            axios.get(`/admin/v1/tenants/${selectedTenantId}`)
                .then(response => {
                // console.log('XXX TenantSelector onChagne dispatching changeTenant with', response.data)
                dispatch(changeTenant(response.data));
            })
                .catch(axiosErrorHandler);
        }
        else {
            dispatch(changeTenant(null));
        }
    };
    return (_jsx("div", { id: "tenant-selector", children: _jsx(TenantSelect, { value: stateSelectedTenantId ?? undefined, allowClear: true, onChange: onChange, style: { "width": "100%" } }) }));
};
export default TenantSelector;
